export default {_name:'icon.fab',module:'Field',view:'Element/Icon/Fab',options:{xs:2}}